<template>
    <div class="col-md-12 page pdf" :key="$route.fullPath">
      <div class="row file-upload-controls">
        <file-list :fileType="pdfFileType" :fileList="pdfList" @change="onPdfSelected" :selectedItem="selectedPdf" class="col-md-3 col-12"></file-list>
        <file-upload :fileType="pdfFileType"></file-upload>
      </div>
      <div class="void-filler-pdf" v-if="selectedPdf === undefined">
        <h1 class="filler-header"><font-awesome-icon icon="search-plus" /></h1>
        <p>Please choose a PDF or upload a PDF to fill the void </p>
      </div>
      <pdf-content-body v-else :selectedPdf="selectedPdf"/>
    </div>
</template>
<script>
import router from '@/router/index';
import { mapGetters,mapActions } from 'vuex';
import { PDF_FILE_TYPE } from '@/config';
import FileListDropdown from '@/components/includes/file/FileListDropdown';
import FileUpload from '@/components/includes/file/FileUpload';
import PdfContentBody from '@/components/includes/pdf/PdfContentBody';
import { PdfsNavigation } from '@/store/modules/fsm/messages';

export default {
  name: 'pdf-page',
  data () {
    return {
      pdfFileType: PDF_FILE_TYPE
    }
  },
  methods: {
    onPdfSelected(selectedPdf) {
      router.push({
        name: PdfsNavigation,
        params: {
          selectedPdf
        }
      });
    }
  },
  props: {
    selectedPdf: {
      type: Number,
      required: false
    }
  },
  components: {
    'file-list': FileListDropdown,
    'file-upload': FileUpload,
    'pdf-content-body': PdfContentBody,
  },
  computed: {
    ...mapGetters('login/pdf', {
      pdfList: 'getPdfList'
    }),
  }
}
</script>


<style scoped lang="scss">
  .page {
    padding-top: 1.0rem;
  }
  .void-filler-pdf {
    color: gray;
    font-size: 1.5rem;
    text-align: center;
    margin-top: 2.0rem;

    .filler-header {
      font-size: 2.5rem;
      text-align: center;
    }
  }
</style>
